module.exports = __webpack_public_path__ + "static/Geneen_illustrations-63533eb15bd2f37d1b5914df83ee7c44.jpg";